export default {
  appName     : 'MiniPOS',
  globalError : '发生错误，请联络技术人员！',
  navbar      : {
    contact  : '联络我们',
    language : {
      tw : '繁體中文',
      cn : '简体中文',
      en : 'English'
    }
  },
  features : {
    customization                 : '支持客制化',
    customization_desc_1          : '增加生物辨识登入、与 MDM 结合，或是想要更换主题……等。',
    customization_desc_2          : '我们接受客制化的需求，助您打造属于您的通信工具。',
    privacy_security              : '私密与安全性',
    privacy_security_desc_1       : '所有信息经过端对端加密，保护您的对话隐私与数据安全',
    privacy_security_desc_2       : '资料可以由客户自行控管',
    streamlining_processes        : '跨平台通信',
    streamlining_processes_desc_1 : '不只是查看信息，',
    streamlining_processes_desc_2 : 'Whisp 让您可以和其他平台上的好友双向传信'
  },
  contact : {
    subject       : 'Whsip联络我们信件',
    submitSuccess : '成功送出！',
    continue      : '继续填写新讯息？'
  },
  redirect : {
    errorMessageTitle : '发生错误！'
  },
  formTemplate : {
    upload       : '上传档案',
    reset        : '重填',
    submit       : '确定送出',
    input        : '输入',
    choose       : '选择',
    beforeRemove : '确定移除',
    handleExceed : '最多上传一张,请先删除上一选项',
    error        : '失败',
    cancel       : '取消'
  },
  form : {
    required            : '「{field}」为必填。',
    emailRequireMessage : '请输入email',
    emailFormatMessage  : 'Email 格式错误',
    emailPlaceholder    : '请输入email',
    imageSizeLimitMb    : '图片不得超过{limit}mb。',
    buttonConfirm       : '确定',
    search              : '搜寻',
    clear               : '清除',
    back                : '返回'
  },
  policy : {
    copyright : '著作权声明',
    privacy   : '隐私权政策'
  },
  errorPage : {
    403 : {
      p1 : '您没有权限访问该页面',
      p2 : '返回首页',
      p3 : '返回上一页'
    },
    404 : {
      p1 : '您访问的页面不存在！',
      p2 : '返回首页',
      p3 : '返回上一页'
    }
  }
}
